import PlannedGridView from "@/components/PlannedGridView";

export default function PlannedLatenessesView() {
  return (
    <PlannedGridView
      endpointBase="/reports/planned-latenesses-grid"
      pageEyebrow="Planned Lateness"
      defaultScopeLabel="Planned Lateness"
      filenameFallback="rrdc-planned-latenesses"
      cellPalette="amber"
      errorLabel="planned lateness"
    />
  );
}
